import React from 'react';
import styled from 'styled-components';
import Icon from '../../Icon';
import Tooltip from '../../Tooltip';

const CellContainer = styled.div`
  font-family: ${(props) =>
    props.font && !isLeafRow(props.expander, props.row)
      ? props.theme.fonts[props.font]
      : props.theme.fonts.sfcompact};
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
  letter-spacing: normal;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #2b3d54;
  padding: 7px;
  &:hover {
    cursor: ${(props) =>
      props.expander && props.row.children ? 'pointer' : 'default'};
  }
  ${(props) => props.styles}

  .dropdownIcon {
    margin-left: 40px;
    font-size: 10px;
  }

  .childRowIcon {
    width: 6px;
    height: 12px;
    border-left: 1px solid rgba(31, 43, 55, 0.3);
    border-bottom: 1px solid rgba(31, 43, 55, 0.3);
    margin-right: 8px;
  }

  .removeContainer {
    width: 16px;
    min-width: 16px;
    min-height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(20, 29, 38, 0.12);
    color: rgba(39, 53, 68, 0.5);
    margin-right: 20px;
    font-size: 12px;
  }
  .removeContainer:hover {
    cursor: pointer;
  }

  a {
    color: inherit;
    text-decoration: none !important;
  }

  a:hover {
    cursor: pointer;
  }
`;

const isLeafRow = (expander, row) =>
  expander && !row.children && row._nestingLevel !== 0;

const Cell = ({
  children,
  removable,
  onClick,
  removeClick,
  expander,
  tooltip,
  ...otherProps
}) => {
  const { row } = otherProps;
  return tooltip ? (
    <Tooltip {...tooltip}>
      <CellContainer
        onClick={expander && row.children ? onClick : null}
        expander={expander}
        {...otherProps}
      >
        {removable && (
          <div
            className="removeContainer"
            onClick={(e) => {
              e.stopPropagation();
              removeClick(row._original.id);
            }}
          >
            <Icon icon="close" />
          </div>
        )}
        {isLeafRow(expander, row) && <div className="childRowIcon" />}
        {children}
        {expander && row.children && (
          <Icon className="dropdownIcon" icon="dropdown" />
        )}
      </CellContainer>
    </Tooltip>
  ) : (
    <CellContainer
      onClick={expander && row.children ? onClick : null}
      expander={expander}
      {...otherProps}
    >
      {removable && row._nestingLevel == 0 && (
        <div
          className="removeContainer"
          onClick={(e) => {
            e.stopPropagation();
            removeClick(row._original.id);
          }}
        >
          <Icon icon="close" />
        </div>
      )}
      {isLeafRow(expander, row) && <div className="childRowIcon" />}
      {children}
      {expander && row.children && (
        <Icon className="dropdownIcon" icon="dropdown" />
      )}
    </CellContainer>
  );
};

export default Cell;
